import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "m32.927 19.997 2.551 4.42a5.833 5.833 0 0 1-5.05 8.75H26.99v3.334l-8.333-5.834 8.333-5.833v3.333h3.437a.83.83 0 0 0 .785-1.113l-.064-.137-2.551-4.42zm-19.709-4.523.884 10.133-2.884-1.666-1.72 2.976a.83.83 0 0 0 .572 1.237l.15.013h5.103v5H10.22a5.833 5.833 0 0 1-5.052-8.75l1.719-2.977L4 19.775l9.217-4.3zM23.24 4.782a5.83 5.83 0 0 1 2.135 2.135l1.717 2.977 2.888-1.667-.883 10.133-9.22-4.3 2.886-1.666-1.718-2.977a.83.83 0 0 0-1.357-.121l-.086.121-2.55 4.42-4.332-2.5 2.55-4.42a5.834 5.834 0 0 1 7.97-2.135"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }